module.exports = __webpack_public_path__ + "img/ic_star_24px.b585e003.png";